<template>
    <ThLink
        class="menu-item-link"
        v-bind="bind"
    >
        <slot name="default">
            {{ link.text }}
        </slot>
    </ThLink>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import type { LinkFragment } from '@/graphql/api'
import { useCmsLink } from '@/components/cms/index'

import ThLink from '@/components/ui/buttons/ThLink.vue'

const props = defineProps<{
    link: LinkFragment
}>()

const bind = useCmsLink(toRef(() => props.link))
</script>
